import { Link } from 'react-router';

import { CHECKOUT_STEP_MAP, NEW_ADDRESS_STEP, NEW_BILLING_ADDRESS_STEP } from 'constants/checkoutFlow';

import css from 'styles/components/checkout/caap/address/addresslist/addNewAddressDesktop.scss';

const AddNewAddressDesktop = ({ addressType, isBilling }) => (
  <div className={css.hideSmallScreen}>
    <Link
      data-te={isBilling ? 'TE_CHECKOUT_AL_GO_TO_ADD_NEW_BIL' : 'TE_CHECKOUT_AL_GO_TO_ADD_NEW_SHIP'}
      to={isBilling ? `${CHECKOUT_STEP_MAP[NEW_BILLING_ADDRESS_STEP]}?referrer=address` : `${CHECKOUT_STEP_MAP[NEW_ADDRESS_STEP]}?referrer=address`}>
      <div className={css.addAddressBox}>
        <div className={css.addAddressBoxContent}>
          <img alt="" src="https://images-na.ssl-images-amazon.com/images/G/01/checkout/assets/addAddress._CB340499364_.png" />
        </div>
        <div className={css.addAddressBoxContent}>Add a new {addressType} address</div>
      </div>
    </Link>
  </div>
);

export default AddNewAddressDesktop;
